import type { StatusResponse } from '../../entities/round/types';
import { apiFetch } from '../../shared/api/httpClient';

export function fetchStatus() {
  return apiFetch<StatusResponse>('/api/status', { cache: 'no-store' });
}
